import * as actionTypes from '../constants/collectionConstants';

export const collectionReducer = (state = { collections: [] }, action) => {

    switch (action.type) {
        case actionTypes.COLLECTION_REQUESTS:
            return {
                loading: true,
                collections: []
            };
        case actionTypes.COLLECTION_REQUESTS_SUCCESS:
            return {
                ...state,
                loading: false,
                collections: action.payload,
            };
        case actionTypes.COLLECTION_REQUESTS_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};